import React, { useState } from "react";
import { API, graphqlOperation } from "aws-amplify";
import {
  customerByEmailMini,
  userByEmailMini,
} from "../../../graphql/reloadyard/custom-queries";
import { carrierUserByEmailMini } from "../../../graphql/carrier/carrier-queries";

import {
  Backdrop,
  CircularProgress,
  DialogContentText,
  makeStyles,
} from "@material-ui/core";

import { Confirm, SaveButton, useNotify, useRedirect } from "react-admin";
import { useForm } from "react-final-form";

import { logError } from "../../../utils/appUtils";
import { UserStatus } from "../../../utils/constants";
import { emailInviteHTML } from "./emailInviteHTML";
import { emailCustomerInviteHTML } from "./emailCustomerInviteHTML";
import {
  doCreateReloadYardAccount,
  doUpdateReloadYardAccount,
} from "./customerUtils";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
  },
}));

const validateEmailUnicity = async (formData) => {
  debugger;
  try {
    const customerPromise = API.graphql(
      graphqlOperation(customerByEmailMini, { email: formData.email }),
    );
    const carrierPromise = API.graphql(
      graphqlOperation(carrierUserByEmailMini, { email: formData.email }),
    );
    const userPromise = API.graphql(
      graphqlOperation(userByEmailMini, { email: formData.email }),
    );

    const [customerResponse, carrierResponse, userResponse] = await Promise.all(
      [customerPromise, carrierPromise, userPromise],
    );
    const duplicateCustomer = customerResponse.data.customerByEmail.items[0];
    const duplicateCarrier = carrierResponse.data.carrierUserByEmail.items[0];
    const duplicateUser = userResponse.data.userByEmail.items[0];

    if (duplicateUser || duplicateCarrier) {
      return {
        message: `User with this email already exists.`,
      };
    } else if (duplicateCustomer) {
      const reloadYardAccount = duplicateCustomer.reloadYardAccounts?.items[0]; // .find(itm => itm.reloadYardId);
      return {
        message: `User with this email already exists in in your account.`,
        customer: {
          ...duplicateCustomer,
          email: formData.email,
          active: reloadYardAccount?.active, // check if yard already invited this customer (filtered by auth groups)
          firstName: formData.firstName,
        },
      };
    }
  } catch (error) {
    logError(
      "managerApp:customers:ValidateSaveButton:validateEmailUnicity",
      error,
      false,
    );
  }
  return null;
};

export const ValidateCreateButton = (props) => {
  const classes = useStyles();
  const form = useForm();
  const notify = useNotify();
  const redirect = useRedirect();
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [duplicateUser, setDuplicateUser] = useState();
  const [isSaving, setIsSaving] = useState(false);
  const { account } = props;

  const handleValidateSave = async () => {
    let messages = [
      <>
        Once saved, you will not be able to change the Account or contact
        information. <br />
        Please confirm all information before saving. <br />
      </>,
    ];
    const formState = form.getState();
    const formData = formState.values;
    const isValid = !formState.invalid; // Form-level validation status. Submit to force field-level form validation.
    setIsSaving(true);
    debugger;

    if (isValid && account?.id !== formData.accountId) {
      // account details load async after selection; a missing or stale
      // account would write the wrong accountId/accountName
      notify("Account details are still loading. Please try again.", "warning");
      setIsSaving(false);
      return;
    }

    if (isValid) {
      // if valid, check email uniqueness
      const isDuplicate = await validateEmailUnicity(formData);

      if (isDuplicate) {
        if (isDuplicate.customer?.active === "true" || !isDuplicate.customer) {
          // comes from reloadYardAccount?.active
          // Handle duplicate reloadYardAccount CUSTOMER
          // or !isDuplicate.customer
          // yard staff user
          notify(isDuplicate.message, "error");
          setIsSaving(false);
          return; // Halt submission if duplicate found
        } else {
          // handle existing CUSTOMER account
          setDuplicateUser(isDuplicate.customer);
          messages.push(
            <>
              <br />
              This customer already has an account on transloads.co <br />
              {formData.sendInviteEmail ? (
                <>
                  Continue with an invitation for them to join your transload?
                </>
              ) : (
                <>An invitation email will not be sent.</>
              )}
            </>,
          );
        }
      }
    }

    if (!isValid) {
      setIsSaving(false);
      return; // return to edit form
    }
    if (messages.length > 0) {
      // Open Confirm dialog.
      setMessage(
        <DialogContentText>
          {messages.map((msg, index) => (
            <React.Fragment key={index}>{msg}</React.Fragment>
          ))}
        </DialogContentText>,
      );
      setOpen(true);
    }
  };

  const handleDialogClose = () => {
    setOpen(false);
    setIsSaving(false);
  };

  const handleDialogConfirm = async () => {
    setOpen(false);
    debugger;

    if (duplicateUser) {
      // handle existing CUSTOMER account
      await onSuccess({ data: duplicateUser, isDuplicate: true });
    } else {
      handleSave(); // submit and force field-level form validation whether valid or not.
    }
  };

  const handleSave = () => {
    props.handleSubmitWithRedirect(); // submit and force field-level form validation whether valid or not.
  };

  const transform = (data) => {
    debugger;
    data = { ...data };
    data.status = UserStatus.PENDING_REG;
    data.email = data.email.toLowerCase();

    // cleanup form side-effects
    delete data.accountId;
    delete data.acl;
    delete data.description;
    delete data.sendInviteEmail;

    return data;
  };

  const onSuccess = async ({ data, isDuplicate }) => {
    try {
      debugger;
      let emailContent;
      const formData = form.getState().values;

      if (isDuplicate) {
        // handle existing CUSTOMER account
        // add new customerReloadyardAccount record
        if (data.active === "false") {
          // comes from reloadYardAccount?.active
          // update inactive reloadYardAccount
          const reloadYardAccount = data.reloadYardAccounts.items[0];
          reloadYardAccount.active = "true"; // re-activate inactive customer record
          reloadYardAccount.customerId = data.id;
          reloadYardAccount.email = data.email;
          reloadYardAccount.lastName = data.lastName;
          // reloadYardAccount.reloadYardId = window.appUser.reloadYardId;
          // the re-invite may pick a different account than the deleted invite
          reloadYardAccount.accountId = account.id;
          reloadYardAccount.accountName = account.businessName;
          reloadYardAccount.acl = formData.acl;
          reloadYardAccount.description = formData.description || null;

          await doUpdateReloadYardAccount(reloadYardAccount);
        } else {
          // create new reloadYardAccount
          await doCreateReloadYardAccount(
            data,
            formData.acl,
            account,
            formData.description,
          );
        }

        emailContent = emailCustomerInviteHTML(
          data.firstName,
          data.email,
          window.appUser?.firstName,
          window.appUser?.reloadYard.name,
        );
      } else {
        // comes from transform
        await doCreateReloadYardAccount(
          data,
          formData.acl,
          account,
          formData.description,
        );

        emailContent = emailInviteHTML(
          data.firstName,
          data.email,
          window.appUser?.firstName,
          window.appUser?.reloadYard.name,
        );
      }

      if (formData.sendInviteEmail) {
        const response = await API.post("transREST", "/sendEmail", {
          body: {
            to: data.email,
            bcc: ["support@transloads.co"],
            subject: "Your transloads.co Invite Is Waiting",
            template: "emailTemplate.html",
            htmlContent: emailContent,
          },
        });

        if (response.error) {
          throw response.error;
        }
      }

      notify(`User created successfully.`);
      redirect("/customers");
    } catch (error) {
      logError(
        "managerApp:customers:DialogCreateButton:onSuccess",
        error,
        notify,
      );
    } finally {
      setIsSaving(false);
    }
  };

  const onFailure = (error) => {
    setIsSaving(false);
    logError(
      "managerApp:customers:DialogCreateButton:onFailure",
      error,
      notify,
    );
  };

  return (
    <>
      <Backdrop className={classes.backdrop} open={isSaving}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <SaveButton
        {...props}
        submitOnEnter={false}
        undoable={false}
        saving={isSaving}
        handleSubmitWithRedirect={handleValidateSave}
        transform={transform}
        onSuccess={onSuccess}
        onFailure={onFailure}
      />
      <Confirm
        isOpen={open}
        title="Save Confirmation"
        content={message}
        onConfirm={handleDialogConfirm}
        onClose={handleDialogClose}
      />
    </>
  );
};
